import {
  DescriptionOutlined,
  FolderOutlined,
  PeopleAltOutlined,
  SchoolOutlined,
  ShowChartRounded
} from '@mui/icons-material';

export const BACKSPACE_SYSTEM = [
  {
    name: 'Project Management',
    shortName: 'project',
    description: 'Register new project • Update project phase',
    url: `${process.env.REACT_APP_PROJECT_REGISTER_WEB_URL}`,
    icon: <FolderOutlined color="primary" />,
    isActive: true
  },
  {
    name: 'Document Management',
    shortName: 'document',
    description: 'Plan document • Send document to review',
    url: `${process.env.REACT_APP_DOCUMENT_MANAGEMENT_WEB_URL}`,
    icon: <DescriptionOutlined color="primary" />,
    isActive: true
  },
  {
    name: 'Sales Plan',
    shortName: 'sales plan',
    description: 'Plan monthly sales • Track Est. Full Year',
    url: `${process.env.REACT_APP_SALES_PLAN_WEB_URL}`,
    icon: <ShowChartRounded color="primary" />,
    isActive: true
  },
  {
    name: 'Training',
    shortName: 'training',
    description: 'LMS courses • Certificates • Quiz',
    url: `${process.env.REACT_APP_TRAINING_WEB_URL}`,
    icon: <SchoolOutlined color="primary" />,
    isActive: true
  },
  {
    name: 'User Management',
    shortName: 'user',
    description: 'Add new member • Manage permissions',
    url: `${process.env.REACT_APP_USER_MANAGEMENT_WEB_URL}`,
    icon: <PeopleAltOutlined color="primary" />,
    isActive: false
  }
];
